// import React from 'react';
// import './About.css';
// import { useNavigate } from 'react-router-dom';


// const AboutSections = () => {
//   const navigate = useNavigate(); // Line added to initialize navigate

//   return (
//     <div className="About-container">
//     <div className="gallery">
//     <div className="container">
//       <div className="section" style={{ backgroundColor: '#fff' }}>
//       <span className="icon">⬇️</span>
//               <h3>DOWNLOAD REPORT FOR SOCIAL AUDIT</h3>
//         <p>We are providing a platfrom for social related reports.</p>
//         <button onClick={() => navigate('/CategorySelector')}>DOWNLOAD</button>
//       </div>

//       <div className="section" style={{ backgroundColor: '#f9f9f9' }}>
//       <span class="icon">📜</span>

//       <h3>LETTER/CIRCULAR FOR SOCIAL AUDIT</h3>
//         <p>This page for view all social audit related letters and guidlines.</p>
//         <button onClick={() =>  navigate('/PDFSelector')}>DOWNLOAD</button>
//       </div>

//       <div className="section" style={{ backgroundColor: '#fff' }}>
//       <span class="icon">📑</span>
//       <h3>VIEW SOCIAL AUDIT REPORT</h3>
//         <p>This is for view social audit report of Baleswar district.</p>
//         <button onClick={() => alert('Explore our services!')}>VIEW</button>
//       </div>
//     </div>
//     </div>
//     </div>
//   );
// };

// export default AboutSections;
import React from 'react';
import { useNavigate } from 'react-router-dom';

const AboutSections = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      fontFamily: 'Arial, sans-serif',
    background: "radial-gradient(circle at left, #B3E5FC, #FFFFFF)",
      Height: '100%',
      padding: '40px 20px'
    }} id="About">
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {/* Hero Section */}
        <div style={{
          textAlign: 'center',
          marginBottom: '50px'
        }}>
          <h2 style={{
            fontSize: '31px',
            color: '#003d82',
            marginBottom: '15px',
            fontWeight: '700'
          }}>
            About District Social Audit Unit
          </h2>
          <p style={{
            fontSize: '15px',
            color: '#4a5568',
            maxWidth: '800px',
            margin: '0 auto',
            lineHeight: '1.8'
          }}>
            The District Social Audit Unit, Balasore is committed to ensuring transparency and accountability 
            in the implementation of government schemes through systematic social audits and community participation.
          </p>
        </div>

        {/* Services Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '30px',
          marginBottom: '50px'
        }}>
          {/* Card 1 - Download Report */}
          <div style={{
            backgroundColor: '#FFFBF2',
            padding: '40px 30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
            textAlign: 'center',
            transition: 'all 0.3s ease',
            border: '2px solid transparent',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-8px)';
            // e.currentTarget.style.borderColor = '#FFB703';
            e.currentTarget.style.boxShadow = '0 8px 20px #f2e8cd';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.borderColor = 'transparent';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
          }}>
            {/* Professional Download Icon */}
            <div style={{
              width: '50px',
              height: '50px',
              margin: '0 auto 15px',
              backgroundColor: '#e6f2ff',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#003d82" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </div>
            <h3 style={{
              fontSize: '20px',
              color: '#1a202c',
              marginBottom: '15px',
              fontWeight: '700'
            }}>
              DOWNLOAD REPORT FOR SOCIAL AUDIT
            </h3>
            <p style={{
              fontSize: '15px',
              color: '#4a5568',
              lineHeight: '1.6',
              marginBottom: '25px'
            }}>
              We are providing a platform for social related reports.
            </p>
            <button onClick={() => navigate('/CategorySelector')} style={{
              backgroundColor: '#003d82',
              color: 'white',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(0,61,130,0.2)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#002a5c';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#003d82';
              e.currentTarget.style.transform = 'scale(1)';
            }}>
              DOWNLOAD
            </button>
          </div>

          {/* Card 2 - Letter/Circular */}
          <div style={{
            backgroundColor: '#f9f9f9',
            padding: '30px 30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
            textAlign: 'center',
            transition: 'all 0.3s ease',
            border: '2px solid transparent',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-8px)';
            // e.currentTarget.style.borderColor = '#003d82';
            e.currentTarget.style.boxShadow = '0 8px 20px #fff';
            e.currentTarget.style.backgroundColor = '#fff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.borderColor = 'transparent';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
            e.currentTarget.style.backgroundColor = '#f9f9f9';
          }}>
            {/* Professional Document Icon */}
            <div style={{
              width: '50px',
              height: '50px',
              margin: '0 auto 15px',
              backgroundColor: '#e6f2ff',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#003d82" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
            </div>
            <h3 style={{
              fontSize: '20px',
              color: '#1a202c',
              marginBottom: '15px',
              fontWeight: '700'
            }}>
              LETTER/CIRCULAR FOR SOCIAL AUDIT
            </h3>
            <p style={{
              fontSize: '15px',
              color: '#4a5568',
              lineHeight: '1.6',
              marginBottom: '25px'
            }}>
              This page for view all social audit related letters and guidelines.
            </p>
            <button onClick={() => navigate('/PDFSelector')} style={{
              backgroundColor: '#003d82',
              color: 'white',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(0,61,130,0.2)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#002a5c';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#003d82';
              e.currentTarget.style.transform = 'scale(1)';
            }}>
              DOWNLOAD
            </button>
          </div>

          {/* Card 3 - View Report */}
          <div style={{
            backgroundColor: '#F3FBF7',
            padding: '40px 30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
            textAlign: 'center',
            transition: 'all 0.3s ease',
            border: '2px solid transparent',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-8px)';
            // e.currentTarget.style.borderColor = '#1B9C85';
            e.currentTarget.style.boxShadow = '0 8px 20px #a4ded3';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.borderColor = 'transparent';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
          }}>
            {/* Professional View Icon */}
            <div style={{
              width: '50px',
              height: '50px',
              margin: '0 auto 15px',
              backgroundColor: '#e6f2ff',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#003d82" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </div>
            <h3 style={{
              fontSize: '20px',
              color: '#1a202c',
              marginBottom: '15px',
              fontWeight: '700'
            }}>
              VIEW SOCIAL AUDIT REPORT
            </h3>
            <p style={{
              fontSize: '15px',
              color: '#4a5568',
              lineHeight: '1.6',
              marginBottom: '25px'
            }}>
              This is for view social audit report of Balasore district.
            </p>
            <button onClick={() => alert('View Report functionality')} style={{
              backgroundColor: '#003d82',
              color: 'white',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(0,61,130,0.2)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#002a5c';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#003d82';
              e.currentTarget.style.transform = 'scale(1)';
            }}>
              VIEW
            </button>
          </div>
        </div>

        {/* Additional Info Section */}
        <div style={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          marginBottom: '40px'
        }}>
          <h3 style={{
            fontSize: '26px',
            color: '#003d82',
            marginBottom: '20px',
            fontWeight: '700',
            textAlign: 'center'
          }}>
            About Our Services
          </h3>
          <p style={{
            fontSize: '16px',
            color: '#4a5568',
            lineHeight: '1.8',
            textAlign: 'center',
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            The District Social Audit Unit (DSAU) Balasore operates under the Odisha State Social Audit and Transparency (OSSAAT) 
            framework. We facilitate social audits of various government schemes, ensure participatory governance, and empower 
            citizens by providing access to information and enabling them to hold authorities accountable.
          </p>
        </div>
      </div>

      {/* Responsive Styles */}
     <style>{`
  @media (max-width: 768px) {
    .about-grid {
      grid-template-columns: 1fr !important;
    }
  }

  @media (max-width: 480px) {
    .about-page h2 {
      font-size: 23px !important;
    }

    .about-page p {
      font-size: 9px !important;
    }
  }
`}</style>

    </div>
  );
};

export default AboutSections;